import { ChangeDetectorRef, Component, HostListener } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { environment } from 'src/environemnts/environment';

// import { getMessaging, getToken, onMessage, isSupported } from "firebase/messaging";
// import { analytics } from './services/firebaseConfiguration';
import { LoadingService } from './services/loading.service';
import { AuthService } from './services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import { PopupComponent } from './pages/dashboards/popup/popup.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent {

  title = 'Authoring tool';
  loadingVisible: string;
  interval: any;
  message: any;

  constructor(private router: Router, private loadingService: LoadingService, private cd: ChangeDetectorRef, private authService: AuthService, private translateService: TranslateService, public dialog: MatDialog) {

    const language = localStorage.getItem('language');
    translateService.setDefaultLang('en');
    if(language!=null && language != 'undefined'){
      this.translateService.use(language);
    }
    
    if(language == null || language == 'undefined') {
      this.translateService.use('en');
      localStorage.setItem('language','en');
    }
    
    //Manage loading
    this.loadingService.loadingUpdate$.subscribe((response: any) => {
      this.loadingVisible = response;
      this.cd.detectChanges();
    })

    // console.log('Firebase Analytics initialized:', analytics);

    //FIREBASE
    // isSupported().then(firebaseSupported => {
    //   if (firebaseSupported) {
    //     this.requestPermission();
    //     this.listen();
    //   }
    // });





    this.router.events.subscribe(async (e: any) => {

      if (e instanceof NavigationEnd) {
        if (e.url == '/login' || e.url == '/') {

          // Calculate session duration when logout
          if (this.authService.logId != 0) {

            let sessionElapsedTimeInSeconds = Math.round((new Date().getTime() - this.authService.loginTime) / 1000);

            try {

              await firstValueFrom(this.authService.updateLogsSessionDuration(sessionElapsedTimeInSeconds, this.authService.logId));
              this.authService.cleanVariables();
              this.router.navigate(['/']);

            } catch (error: any) {

              let errorText = "error" + error.status;
              this.authService.cleanVariables();
              this.authService.logoutClean();

              //Error Popup 401
              if (errorText.indexOf("error401") != -1) {
                this.showErrorPopUp("general.errorMessageSessionExpired");
              } else {
                this.showErrorPopUp("general.errorMessage");
              }

              throw new Error(`Error in updateLogsSessionDuration() method with user id: ${this.authService.uuid} + ${this.authService.pilot}, error ${(error.status || 'error status not available')}, description ${(JSON.stringify(error.message) || 'error message not available')}, error  ${(JSON.stringify(error.error) || 'error.error not available')}`);

            }

          }

        }


        if (e.url.indexOf("?auth_code") != -1) {

          let position = e.url.indexOf("=")
          let token = e.url.substring(position + 1)
        }
      }

    })

    //Each 2 minutes, the method to update the token is called
    this.interval = setInterval(async () => {

      if (this.authService.sessionToken != "") {

        try {
          await firstValueFrom(this.authService.refreshToken()).then((response: any) => {

            this.authService.sessionToken = response.message;
            sessionStorage.setItem('X-Pasiphae-Auth', response.message);

          })

          if (this.authService.logId != 0) {

            let sessionElapsedTimeInSeconds = Math.round((new Date().getTime() - this.authService.loginTime) / 1000);

            try {
              await firstValueFrom(this.authService.updateLogsSessionDuration(sessionElapsedTimeInSeconds, this.authService.logId));
            } catch (error: any) {

              let errorText = "error" + error.status;
              this.authService.cleanVariables();
              this.authService.logoutClean();
              this.router.navigate(['/']);

              //Error Popup 401
              if (errorText.indexOf("error401") != -1) {
                this.showErrorPopUp("general.errorMessageSessionExpired");
              } else {
                this.showErrorPopUp("general.errorMessage");
              }

              console.error(`Error in updateLogsSessionDuration() method with user id: ${this.authService.uuid} + ${this.authService.pilot}, error ${error.status}, description ${JSON.stringify(error.message)}, error  ${JSON.stringify(error.error)}`);
             
            }

          }

        } catch (error: any) {

          this.authService.cleanVariables();
          this.authService.logoutClean();

              //Error Popup 403
              let errorText = "error" + error.status;
              if (errorText.indexOf("error403") != -1) {
                this.showErrorPopUp("general.errorMessageSessionExpired");
              } else {
                this.showErrorPopUp("general.errorMessage");
              }

          this.router.navigate(['/']);

          console.log("Error :", JSON.parse(JSON.stringify(error)));
          throw new Error(`Error in refreshToken() method with user : ${this.authService.userProfileData.id}, error ${(error.status || 'error status not available')}, description ${(JSON.stringify(error.message) || 'error message not available')}, error  ${(JSON.stringify(error.error) || 'error.error not available')}`);

        }

      }
      // },10000); //10 sec
    }, 120000); //2 mins
    // }, 2400000);  //  40 mins
      //  }, 30000);


  }





  async ngOnInit() {

  
    window.addEventListener('beforeunload', (event) => {
        event.preventDefault();
        event.returnValue = ''; // required for most browsers
      });

    const navEntries = performance.getEntriesByType("navigation") as PerformanceNavigationTiming[];

    if (navEntries.length > 0) {


      if (navEntries.length > 0 && navEntries[0].type === "reload") {

        if (sessionStorage.getItem('logId') && sessionStorage.getItem('loginTime')) {

          this.loadingService.changeSpinnerStatus('true', 'app');

          let loginTime = Number(sessionStorage.getItem('loginTime'));

          let sessionElapsedTimeInSeconds = Math.round((new Date().getTime() - loginTime) / 1000);

          try {
            await firstValueFrom(this.authService.updateLogsSessionDuration(sessionElapsedTimeInSeconds, Number(sessionStorage.getItem('logId'))))

            this.authService.cleanVariables();

            this.loadingService.changeSpinnerStatus('false', 'app');
          } catch (error: any) {

            console.log("ERROR :", error)

            this.authService.cleanVariables();

            this.loadingService.changeSpinnerStatus('false', 'app');

            throw new Error(`Error in updateLogsSessionDuration() method with user id: ${this.authService.uuid} + ${this.authService.pilot}, error ${(error.status || 'error status not available')}, description ${(JSON.stringify(error.message) || 'error message not available')}, error  ${(JSON.stringify(error.error) || 'error.error not available')}`);


          }

        }

      }
    }
  }

  /**
 * Firebase permissions request
 */
  // async requestPermission() {

  //   const messaging = getMessaging();

  //   console.log("environment.firebaseConfig.vapidKey :", environment.firebaseConfig.vapidKey)

  //   getToken(messaging,
  //     { vapidKey: environment.firebaseConfig.vapidKey }).then(
  //       (currentToken) => {

  //         console.log("CURRENT TOKEN :", currentToken)
  //         if (currentToken) {
  //           localStorage.setItem("firebaseToken", currentToken);
  //         } else {
  //           console.log('No registration token available. Request permission to generate one.');
  //         }
  //       }).catch((err) => {
  //         console.log("Error :", JSON.parse(JSON.stringify(err)));

  //         if (JSON.stringify(err).indexOf("Failed to execute 'subscribe' on 'PushManager'") != -1) { //This error appears the first time due to the logic of the FCM in Chrome
  //           this.requestPermission();
  //         } else {
  //           console.log("Error code :", err)
  //         }
  //         console.log('An error occurred while retrieving token. ', JSON.parse(JSON.stringify(err)).code, err);
  //         throw new Error('An error occurred while retrieving token. with Professional Id ' + localStorage.getItem("professionalId") + JSON.stringify(err));
  //       });
  // }

  /**
* Pop-up to show an error ocurred
*/
  showErrorPopUp(message: string) {

    //SHOW ERROR POPUP
    this.dialog.open(PopupComponent, {
      disableClose: true,
      width: '640px',
      height: '160px',
      data: {
        type: "attentionInfo",
        headerText: this.translateService.instant("login.attention"),
        generalText: this.translateService.instant(message),
        button: ["Ok"]
      },
    }).afterClosed().subscribe(async () => {

      if (message == 'general.errorMessageSessionExpired') {
        this.router.navigate(['/']);
      }

    })

  }


  /**
 * Firebase listen for notifications
 */
  // listen() {
  //   const messaging = getMessaging();
  //   onMessage(messaging, (payload) => {

  //     console.log("PAYLOAD :", payload)
  //     this.message = payload;

  //   });
  // }



}
